<template>
  <div>
    <!-- 저장하기 -->
    <div id="non-sticky" class="flex-end" style="margin: 12px 0">
      <div class="flex-align" style="gap: 10px; flex-wrap: wrap">
        <!-- 상품 주문/전환 퍼포먼스 정보 -->
        <btn-product-order-performance v-if="is_modify"
          :prod="prod" :performance="performance"
          productType="공간 전화 주문"
          :conversion="conversion"
          :disabled="isPartner"></btn-product-order-performance>
        <button v-if="$route.query.id && $route.query.id !== ''" class="button is-gray" @click="showProduct">상품 미리보기</button>
        <button v-if="isMobile || (!isMobile && prodTab === 0)" class="button is-primary" @click="saveData">저장하기</button>
      </div>
    </div>
    <div id="sticky" style="display: none">
      <div class="flex-align fixed">
        <span class="level-title" style="flex: 1">
          <strong class="flex-align">상품 정보</strong>
        </span>
        <div class="flex-align" style="gap: 0 10px">
          <btn-product-order-performance v-if="is_modify"
            :prod="prod" :performance="performance"
            productType="공간 전화 주문"
            :conversion="conversion"
            :disabled="isPartner"></btn-product-order-performance>
          <!--<button v-if="$route.query.id && $route.query.id !== ''" class="button is-gray" @click="showProduct">상품 미리보기</button>-->
          <button v-if="prodTab === 0" class="button is-primary" @click="saveData">저장하기</button>
        </div>
      </div>
    </div>

    <div :style="{height: isFixed ? '50px' : '0px'}"></div>
    <template v-if="prodTab === 0">
      <div class="detector"></div>
      <div class="columns is-multiline">
        <!-- 왼쪽 레이아웃 -->
        <div class="column is-7">

          <!-- 상품 카테고리 -->
          <a id="sb_category"></a>
          <div class="box tab-item">
            <admin-box-item title="카테고리 선택*"
                            :tip="'상품이 노출될 카테고리를 선택합니다.'"
                            :disabled="isPartner">
              <template #title>
                <button class="button flex-center text-primary modify-btn"
                        @click="routerPush('/office/admin/space/category/create')">
                  <i class="material-icons-outlined text-primary" style="font-size: 16px">edit</i>
                  <div class="size-13 weight-400">편집</div>
                </button>
              </template>
              <div class="columns is-multiline">
                <div class="column is-full">
                  <lp-adm-drop-input ref="adminput_prod"
                                     :data.sync="catArr1"
                                     :selectVal="selectedCategory(prod.category1_id, 'cat1')"
                                     @onSelect="res => clickCategory(res.value, 'cat1')"
                                     placeholder="1차 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                  <lp-adm-drop-input ref="adminput_prod"
                                     :data.sync="cat2"
                                     :selectVal="selectedCategory(prod.category2_id, 'cat2')"
                                     @onSelect="res => clickCategory(res.value, 'cat2')"
                                     placeholder="2차 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                  <lp-adm-drop-input ref="adminput_prod"
                                     :data.sync="cat3"
                                     :selectVal="selectedCategory(prod.category3_id, 'cat3')"
                                     @onSelect="res => clickCategory(res.value, 'cat3')"
                                     placeholder="3차 카테고리"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:12px;"></lp-adm-drop-input>
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- 주문 전환 방식 -->
          <template v-if="enablePanel('panel2') && this.prod.category1_id">
            <a id="sb_inquiry_conversion"></a>
            <div class="box tab-item">
              <admin-box-item title="문의 전환 선택" :disabled="isPartner" :showToggleButton="true">
                <admin-form-item label="문의 전환" desc="상품에 지정한 파트너의 연락처, 이메일로 문의가 연결됩니다.">
                  <lp-radio :val.sync="prod.inquiry_conversion_type"
                            value_name="value"
                            label_name="label"
                            :data="inquiryConversionArr"></lp-radio>
                </admin-form-item>
                <!--<admin-form-item label="결제방식"
                                 v-if="[0,1,2,5,6].indexOf(prod.order_conversion_type) === -1">
                  <lp-radio :val.sync="prod.payment_type"
                            value_name="value"
                            label_name="label"
                            :data="paymentTypeArr"></lp-radio>
                </admin-form-item>
                <div v-else style="height:46px"></div>-->
              </admin-box-item>
            </div>
          </template>
          <!-- SNS 문의 전환 설정 -->
          <template v-if="isInternalPlugin('sns_inquiry')">
            <a id="sb_sns_inquiry"></a>
            <div class="box tab-item" v-if="isInternalPlugin('sns_inquiry')">
            <admin-box-item title="SNS 문의 전환 설정" subtitle="파트너에게 문의할 수 있는 SNS 채널을 선택하고 링크를 입력합니다.">
              <admin-form-item label="SNS 채널">
                <lp-radio :val.sync="prod.sns_inquiry_type"
                          value_name="value"
                          label_name="label"
                          :data="[{label:'파트너 SNS 정보와 동일',value:0},{label:'상품별 개별 설정',value:1}]"></lp-radio>
                <div class="columns is-multiline" style="margin-top:12px" v-if="prod.sns_inquiry_type===1">
                  <div class="column is-3">
                    <lp-check-bool :checked-val.sync="prod.enable_naver"
                                   label="네이버블로그"></lp-check-bool>
                    <input class="input"
                           style="margin-top:8px"
                           :value="prod.naver"
                           @input="e => prod.naver = e.target.value"
                           type="text"
                           maxlength="50">
                  </div>
                  <div class="column is-3">
                    <lp-check-bool :checked-val.sync="prod.enable_kakao"
                                   label="카카오톡"></lp-check-bool>
                    <input class="input"
                           style="margin-top:8px"
                           :value="prod.kakao"
                           @input="e => prod.kakao = e.target.value"
                           type="text"
                           maxlength="50">
                  </div>
                  <div class="column is-3">
                    <lp-check-bool :checked-val.sync="prod.enable_instagram"
                                   label="인스타그램"></lp-check-bool>
                    <input class="input"
                           style="margin-top:8px"
                           :value="prod.instagram"
                           @input="e => prod.instagram = e.target.value"
                           type="text"
                           maxlength="50">
                  </div>
                  <div class="column is-3">
                    <lp-check-bool :checked-val.sync="prod.enable_homepage"
                                   label="홈페이지"></lp-check-bool>
                    <input class="input"
                           style="margin-top:8px"
                           :value="prod.homepage"
                           @input="e => prod.homepage = e.target.value"
                           type="text"
                           maxlength="50">
                  </div>
                </div>
              </admin-form-item>
            </admin-box-item>
          </div>
          </template>
          <!-- 상품 기본정보 -->
          <a id="sb_product_basic"></a>
          <div class="box tab-item">
            <admin-box-item title="상품 기본정보" :disabled="isPartner">
              <div class="columns is-multiline">

                <div class="column is-3" v-if="isInternalPlugin('product_priority')">
                  <admin-form-item label="노출 우선순위">
                    <input class="input"
                           v-model.number="prod.priority"
                           placeholder="노출 우선순위를 입력하세요. (0~99)"
                           type="number">
                  </admin-form-item>
                </div>

                <div class="column is-full"
                    v-if="$store.getters.mode==='admin'">
                  <admin-form-item label="파트너*">
                    <lp-adm-drop-input :data.sync="partners"
                                      :selectVal="partnerName"
                                      @onSelect="selectPartnerId"
                                      placeholder="검색 후 선택"
                                      listAlign="left"
                                      width="250px"
                                      style="display:inline-block; margin-right:12px;"></lp-adm-drop-input>
                    <lp-check-bool :checkedVal.sync="isEqualPartner" v-if="partnerName !== ''"
                                  style="margin:8px 0"
                                  label="파트너 정보와 상품 정보가 동일합니다."></lp-check-bool>
                  </admin-form-item>
                </div>
                <div class="column is-full" v-if="isInternalPlugin('product_video')">
                  <admin-form-item label="상품 동영상">
                    <lp-input-video :file.sync="prod.video"></lp-input-video>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품 대표 이미지" :desc="getRatio('product_card')">
                    <drag-img-single :img.sync="prod.first_img"></drag-img-single>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품 이미지" :desc="getRatio('product_detail_slider')">
                    <drag-img-multiple :imgs.sync="prod.imgs"></drag-img-multiple>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품 노출 여부">
                    <lp-radio :val="prod.enable_prod"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'노출',value:true}, {label:'비노출', value:false}]"
                              @onSelect="onSelectedProdState"></lp-radio>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품명*">
                    <input class="input"
                          :value="prod.name"
                          @input="e => prod.name = e.target.value"
                          placeholder="상품명을 입력해주세요."
                          type="text">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품 한줄 설명">
                    <input class="input"
                          :value="prod.simple_desc"
                          @input="e => prod.simple_desc = e.target.value"
                          placeholder="상품에 대한 간단한 설명을 하는 곳 입니다."
                          type="text" maxlength="70">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품 태그"
                                  desc="상품 태그 생성은 키워드 입력 후 엔터(enter)를 입력하시면 됩니다."
                                  tip="상품 검색 시 키워드로 활용되며, 최대 10개까지 등록 가능합니다.">
                    <lp-input-tag :data="prod.tags"></lp-input-tag>
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="상품코드">
                    <input class="input"
                          :value="prod.code"
                          @input="e => prod.code = e.target.value"
                          placeholder="상품코드를 입력해주세요."
                          type="text">
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
          <!-- 위치 정보 -->
          <a id="sb_location"></a>
          <panel-product-location ref="location" :prod="prod"></panel-product-location>

          <!-- 맞춤 DB -->
          <template v-if="enablePanel('panel3') && prod_param && prod_param.length>0">
            <a id="sb_custom_db"></a>
            <div class="box">
              <admin-box-item title="맞춤 DB" :disabled="isPartner" :showToggleButton="true">
                <div class="columns is-multiline">
                  <div class="column is-full"
                      v-for="(param, index) in prod_param"
                      v-bind:key="'param_input'+index">
                    <admin-form-item :label="param.name">

                      <input-param :param.sync="param"></input-param>
                    </admin-form-item>
                  </div>
                </div>
              </admin-box-item>
            </div>
          </template>
        </div>

        <!-- 오른쪽 레이아웃 -->
        <div class="column is-5">
          <!--<product-preview v-if="enablePreview" :prod="prod"></product-preview>-->

          <!-- 전화연결  -->
          <div class="box">
            <admin-box-item title="전화번호 연결">
              <admin-form-item label="전화번호">
                <input class="input"
                      style="display: inline-block;margin-right:12px;width:250px;"
                      :value="prod.phone"
                      @input="e => prod.phone = e.target.value"
                      placeholder="010-1234-5678"
                      type="text"
                      maxlength="13"
                      :disabled="isEqualPartnerPhone">
                <lp-check-bool v-if="partner_id>0" :checkedVal.sync="isEqualPartnerPhone" style="margin-top:12px"
                              label="파트너 대표번호와 동일합니다."></lp-check-bool>
              </admin-form-item>
            </admin-box-item>
          </div>
          <!-- 가격 정보 -->
          <panel-product-price ref="productPrice"
                               :prod="prod" :panel="panel" @calcPrice="calcPrice()"
                               :disabled="isPartner"
                               :prod_price="prod_price"></panel-product-price>

          <!-- 본인(성인)인증 여부 -->
          <a id="sb_verify" v-if="isInternalPlugin('age_verify') || isInternalPlugin('identity_verify')"></a>
          <div class="box tab-item" v-if="isInternalPlugin('age_verify') || isInternalPlugin('identity_verify')">
            <admin-box-item :title="verifyTitle" :disabled="isPartner">
              <lp-radio :val.sync="prod.enable_age_verify"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:true}, {label:'사용 안 함', value:false}]"></lp-radio>
            </admin-box-item>
          </div>

          <!-- 포인트 적립 설정 -->
          <a id="sb_point_coupon" v-if="isAdmin && enablePanel('panel5') && isInternalPlugin('point_coupon')"></a>
          <div class="box tab-item" v-if="isAdmin && enablePanel('panel5') && isInternalPlugin('point_coupon')">
            <admin-box-item title="포인트 적립 설정" :disabled="isPartner" :showToggleButton="true">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="포인트 적립 사용여부">
                    <lp-radio :val.sync="prod_price.is_point"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'개별설정',value:true}, {label:'기본설정', value:false}]"></lp-radio>
                  </admin-form-item>
                </div>
                <div v-if="prod_price.is_point">
                  <div class="column is-full">
                    <admin-form-item label="적립 방법">
                      <lp-radio :val.sync="prod_price.point_type"
                                value_name="value"
                                label_name="label"
                                :showInput="true"
                                :block="true"
                                @onEdit="res => onEdit(res, 'point')"
                                :data="[{label:'적립율', value:0, num: prod_price.point_rate, unit:'%'},
                                          {label:'적립금', value:1, num: prod_price.point, unit:'원'}]"></lp-radio>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="적립 예정 포인트">
                      <label class="label"
                            style="padding-left: 4px;">
                        {{ prod_price.salePoint | currency }}
                      </label>
                    </admin-form-item>
                  </div>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 거래 수수료 -->
          <a id="sb_comm_type" v-if="isAdmin && enablePanel('panel7')"></a>
          <div class="box tab-item" v-if="isAdmin && enablePanel('panel7')">
            <admin-box-item title="상품 거래 수수료 설정" :disabled="isPartner" :showToggleButton="true">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="수수료">
                    <lp-radio :val.sync="prod_price.is_comm"
                              value_name="value"
                              label_name="label"
                              :data="[{label:'개별설정',value:true}, {label:'기본설정', value:false}]"></lp-radio>
                  </admin-form-item>
                </div>
                <div v-if="prod_price.is_comm">
                  <div class="column is-full">
                    <admin-form-item label="수수료 방법">
                      <lp-radio :val.sync="prod_price.comm_type"
                                value_name="value"
                                label_name="label"
                                :showInput="true"
                                :block="true"
                                @onEdit="res => onEdit(res, 'comm')"
                                :data="[{label:'수수료율', value:0, num: prod_price.comm_rate, unit:'%'},
                                          {label:'수수료금액', value:1, num: prod_price.comm_price, unit:'원'}]"></lp-radio>
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="수수료 가격">
                      <label class="label"
                            style="padding-left: 4px;">
                        {{ prod_price.saleComm | currency }}
                      </label>
                    </admin-form-item>
                  </div>
                </div>
                <div class="column is-full" v-if="false">
                  <admin-form-item label="수수료 적용 기간">
                    <div class="flex" style="flex-wrap:wrap">
                      <div style="align-items: center;">
                        <admin-date-picker
                          type="datetime"
                          :data="prod_price.comm_start"
                          @setDate="selDateMin"></admin-date-picker>
                      </div>
                      <div class="lp-dating">&#126;</div>
                      <div style="align-items: center;">
                        <admin-date-picker
                          type="datetime"
                          :data="prod_price.comm_end"
                          @setDate="selDateMax"></admin-date-picker>
                      </div>
                    </div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 상품 SEO 정보 -->
          <a id="sb_seo" v-if="enablePanel('panel10')"></a>
          <div class="box tab-item" v-if="enablePanel('panel10')">
            <admin-box-item title="상품 SEO 정보" :disabled="isPartner" :showToggleButton="true">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="타이틀(Title)">
                    <input class="input"
                          :value="prod_seo.title"
                          @input="e => prod_seo.title = e.target.value"
                          placeholder="타이틀을 입력하세요."
                          type="text" maxlength="30">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="메타태그 작성자(Author)">
                    <input class="input"
                          :value="prod_seo.author"
                          @input="e => prod_seo.author = e.target.value"
                          placeholder="메타태그 작성자를 입력하세요."
                          type="text" maxlength="30">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="메타태그 설명(Description)">
                    <input class="input"
                          :value="prod_seo.desc"
                          @input="e => prod_seo.desc = e.target.value"
                          placeholder="메타태그 설명을 입력하세요."
                          type="text" maxlength="30">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="메타태그 키워드(Keyword)">
                    <input class="input"
                          :value="prod_seo.keyword"
                          @input="e => prod_seo.keyword = e.target.value"
                          placeholder="메타태그 키워드를 입력하세요."
                          type="text" maxlength="30">
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>


        <div class="column is-full">
          <!-- 상품 옵션 정보 -->
          <!--<template v-if="enablePanel('panel8')">-->
          <template v-if="false">
            <a id="sb_product_option"></a>
            <div class="box tab-item">
              <admin-box-item title="상품 옵션 정보" :showToggleButton="true">
                <div class="columns is-multiline relative">
                  <div class="column is-full">
                    <admin-form-item label="옵션 사용여부">
                      <lp-radio :val.sync="prod.enable_option"
                                value_name="value"
                                label_name="label"
                                :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                    </admin-form-item>
                  </div>
                  <div class="column is-full" v-if="prod.enable_option">
                    <admin-form-item label="옵션 설정">
                      <button class="button is-primary"  @click="$modal.show('optionModal')">상품 옵션 구성</button>
                    </admin-form-item>
                  </div>
                  <div class="box-disabled" v-if="isPartner"></div>
                </div>
                <!--<lp-prod-option-stocks :selectors="selectorStocks"
                                       :requiredOptionStockUsing="requiredOptionStockUsing"
                                       @checkRequiredOption="checkRequiredOption"
                                       :requiredOptionTitle="requiredOptionTitle"
                                       :order_conversion_type="prod.order_conversion_type"
                                       v-if="prod.enable_option"></lp-prod-option-stocks>-->
              </admin-box-item>
            </div>
          </template>

          <modal name="optionModal" :adaptive="true" :width="800" height="auto" class="modal-style" @closed="closeOption">
            <div class="lp-modal-wrapper">
              <admin-box-item title="상품 옵션 구성" :useTab="false"
                              subtitle="상품 옵션을 직접 구성하거나 옵션 템플릿에서 가져와서 구성할 수 있습니다.">
                <lp-prod-option :selectors="selectors"
                                :is_modify="is_modify"
                                @closeOption="closeOption"
                                :category1="prod.category1_id"
                                :category2="prod.category2_id"
                                :category3="prod.category3_id"
                                :order_conversion_type="prod.order_conversion_type"></lp-prod-option>
              </admin-box-item>
            </div>
          </modal>

          <!-- 상품 재고 설정 -->
          <!--<div class="box" v-if="visibleStockPanel">
            <admin-box-item :title="panel.stock.title" :showToggleButton="true">
              <div class="columns is-multiline">
                &lt;!&ndash; 재고 사용여부 &ndash;&gt;
                <div class="column is-full">
                  <admin-form-item v-if="selectors.length === 0"
                                   :label="panel.stock.enable_stock_label">
                    <lp-radio :val.sync="prod.stock_type"
                              value_name="value"
                              label_name="label"
                              @onSelect="res => prod.stock_type=res"
                              :data="[{label:'사용',value:0},{label:'무한대',value:1}]"></lp-radio>
                  </admin-form-item>
                  <div class="label"
                       v-if="selectors.length > 0">상품 옵션 재고의 합</div>
                </div>
                &lt;!&ndash; 재고 사용 &ndash;&gt;
                <div v-if="prod.stock_type===0 && selectors.length === 0">
                  &lt;!&ndash; 입고 수량 &ndash;&gt;
                  <div class="column is-full flex-align">
                    <admin-form-item :label="panel.stock.input_number_label">
                      <div style="display:flex;align-items: center">
                        <input class="input product-short-input"
                               v-model="addCount"
                               @keyup.enter="addStock"
                               type="number">
                        <button class="button is-primary"
                                style="margin-left:8px;width:48px"
                                @click="addStock">추가</button>
                      </div>
                    </admin-form-item>
                  </div>
                  &lt;!&ndash; 주문 수량 &ndash;&gt;
                  <div class="column is-full" v-if="$route.query.id">
                    <admin-form-item :label="panel.stock.order_number_label"
                                     justifyContent="space-between"
                                     :isFlex="true">
                      {{ prod.ordered_count }}개
                    </admin-form-item>
                  </div>
                  &lt;!&ndash; 재고 수량 &ndash;&gt;
                  <div class="column is-full" v-if="$route.query.id">
                    <admin-form-item :label="panel.stock.stock_number_label"
                                     justifyContent="space-between"
                                     desc="재고 수량이 0개 인 경우에는 자동 '품절'처리 됩니다."
                                     :isHeaderBlock="true"
                                     :isFlex="true">
                      {{prod.stock}}개</admin-form-item>
                  </div>
                  &lt;!&ndash;&lt;!&ndash; 재고 품절 여부 &ndash;&gt;
                  <div class="column is-full">
                    <admin-form-item :label="panel.stock.soldout_label">
                      <lp-radio :val.sync="prod.soldout"
                                value_name="value"
                                label_name="label"
                                @onSelect="res => prod.soldout=res"
                                :data="[{label:'품절',value:true},{label:'정상',value:false}]"></lp-radio>
                    </admin-form-item>
                  </div>&ndash;&gt;
                </div>

                &lt;!&ndash; 상품 옵션 재고의 합 &ndash;&gt;
                <div class="column is-full" v-if="selectors.length > 0">
                  <div v-if="selectors.length > 0">
                    <div class="flex" style="justify-content: space-between;width:100%;line-height:1.7rem"
                         v-for="(selector,idx) in selectorStocks" :key="'selector-'+idx">
                      <div>{{ selector.name }}</div>
                      <div>{{ selector.stock }}개 남음 / 누적 {{ selector.ordered_count }} 개 주문</div>
                    </div>
                  </div>
                </div>
              </div>
            </admin-box-item>
          </div>-->
          <!-- 상품 상세정보 -->
          <a id="sb_product_detail"></a>
          <div class="box">
            <admin-box-item title="상품 상세정보" :disabled="isPartner">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item>
                    <lp-editor :text.sync="prod.info"></lp-editor>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 상품 공통 고시정보 -->
          <a id="sb_product_common_info"></a>
          <div class="box">
            <admin-box-item title="상품 공통 고시정보" :disabled="isPartner">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item>
                    <div class="prod-reg-content">
                      <div v-for="(common_item, common_idx) in custom_common_info_arr" :key="`common-${common_idx}`"
                        class="common-info">
                        <lp-check-bool :checkedVal.sync="prod[common_item.key]"
                                       v-if="common_item.label"
                                       style="margin-bottom:12px"
                                       :labelStyle="{fontSize: '14px', color: '#363636', fontWeight: 700}"
                                       :label="common_item.label"></lp-check-bool>
                        <lp-editor :text.sync="prod.common_info[common_item.value]"
                                   style="margin-bottom:12px"
                                   v-if="prod[common_item.key]"></lp-editor>
                        <div v-else class="size-13" style="color:#787878">*미사용 시 파트너 상품 정보 제공 고시로 대체</div>
                      </div>
                    </div>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>

          <!-- 연관 상품 -->
          <template v-if="prod.name && enablePanel('panel11')">
            <a id="sb_related_product"></a>
            <div class="box tab-item">
              <admin-box-item title="관련 상품" :disabled="isPartner">
                <space-related-products :products.sync="prod.related_products"></space-related-products>
              </admin-box-item>
            </div>
          </template>
        </div>
      </div>
    </template>
    <!-- 저장하기 -->
    <div v-if="prodTab === 0" class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
    <!-- 결제방식 확인 모달 -->
    <!--<modal name="checkPayMethodModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div style="padding:20px 0">
          결제 정보 입력이 필요한 팩입니다.<br>
          서비스 설정 관리 > 플랫폼 주문/결제 설정에서 결제 정보를 입력해주세요.
        </div>
        <div class="btn-group-justify-end">
          <button class="button" @click="$modal.hide('checkPayMethodModal')">취소</button>
          <button class="button is-primary" @click="routerPush(getPath('service/setting'))">설정하러가기</button>
        </div>
      </div>
    </modal>-->
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import moment from 'moment'
  import InputImg from '../../module/common/InputImg'

  import LpAdmBtn from '../../module/common/LpAdmBtn'
  import LpSortDropDown from "../../module/common/LpSortDropDown"
  import LpCheckBool from "../../module/common/LpCheckBool"
  import LpCheckGroup from '../../module/common/LpCheckGroup'
  import LpRadio from "../../module/common/LpRadio"
  import LpInput from "../../module/common/LpInput"
  import LpInputText from "../../module/common/LpInputText"
  import LpInputTag from "../../module/common/LpInputTag"
  import LpAddress from '../../module/common/LpAddress'
  import LpDropdown from "../../module/common/LpDropdown"
  import LpProdOptionStocks from "../../module/common/LpProdOptionStocks"
  import LpRegionDropDown from "../../module/common/LpRegionDropDown"
  import InputParam from "../../module/custom/InputParam";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import LpEditor from "../../module/common/LpEditor";
  import InputFile from "../../module/common/InputFile";
  import CreateMixin from "@/mixins/CreateMixin"
  import LpProdDeliveryPrice from "../../module/common/lpProdDeliveryPrice";
  import ProductPanelMixin from "../../../mixins/ProductPanelMixin";
  import PanelProductPrice from "../product/component/PanelProductPrice";
  import SpaceRelatedProducts from "./SpaceRelatedProducts";
  import Tab1 from "../../module/common/Tab1";
  import PanelDayPrice from "../product/component/PanelDayPrice";
  import PanelSuperVisor from "../product/component/PanelSuperVisor";
  import LpInputVideo from "../../module/common/LpInputVideo";
  import DragImgMultiple from "../../module/common/DragImgMultiple";
  import DragImgSingle from "../../module/common/DragImgSingle";
  import ProductPreview from "../product/component/ProductPreview";
  import PanelProductLocation from "../product/component/PanelProductLocation";
  import PanelProductOrderPerformance from "../product/component/PanelProductOrderPerformance";
  import BtnProductOrderPerformance from "../product/component/BtnProductOrderPerformance";
  import LpProdOption from "../../module/common/LpProdOption";

  export default {
    name: 'ProductReg',
    layout: 'Main',
    components: {
      LpProdOption,
      BtnProductOrderPerformance,
      PanelProductOrderPerformance,
      PanelProductLocation,

      ProductPreview,
      DragImgSingle,
      DragImgMultiple,
      LpInputVideo,
      PanelSuperVisor,
      PanelDayPrice,
      Tab1,
      SpaceRelatedProducts,
      PanelProductPrice,
      LpProdDeliveryPrice,
      InputFile,
      draggable,
      LpEditor,
      LpAdmDropInput,
      InputParam,
      LpDropdown,
      LpInputTag,
      LpInputText,
      LpInput,
      LpRadio,
      LpCheckBool,
      LpCheckGroup,
      LpSortDropDown,
      InputImg,
      LpAdmBtn,
      LpAddress,
      LpProdOptionStocks,
      LpRegionDropDown,
    },
    mixins: [
      CreateMixin,
      ProductPanelMixin
    ],
    watch:{
      modalStatus(n) {
        // 최초 등록후 모달 취소 했을 경우
        if(n === 'cancel') {
          if(this.prod.id) {
            this.$router.replace(`${this.$route.path}?id=${this.prod.id}`);;
          }
        }
      },
      '$route'() {
        if(this.$route.query.id)
          this.is_modify=true;
      },
      partner_id(n) {
        if(n>0) {
          this.$axios.get(this.getUrl(`space/partner/${n}`)).then(res=>{
            this.partner = res.data.partner;
          });
        }
      },
      'prod.phone'(n) {
        this.prod.phone = autoHyphenPhone(this.prod.phone)
      },
      'prod_price.discount_type'(n){
        if (n === 0)
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - (this.prod_price.price * parseFloat(this.prod_price.discount_rate) / 100);
        else
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - parseInt(this.prod_price.discount_price);
      },
      'prod_price.comm_type'(n){
        if (n === 0)
          this.prod_price.saleComm = parseInt(this.prod_price.price) * parseFloat(this.prod_price.comm_rate) / 100;
        else
          this.prod_price.saleComm = parseInt(this.prod_price.comm_price);
      },
      'prod_price.point_type'(n){
        if (n === 0)
          this.prod_price.salePoint = parseInt(this.prod_price.price) * parseFloat(this.prod_price.point_rate) / 100;
        else
          this.prod_price.salePoint = parseInt(this.prod_price.point);
      },
      isEqualPartnerPhone(n){
        if(n && this.partner_id>0){
          this.equalPartnerPhone();
          this.prod.enable_phone = true;
          return true;
        }
        else {
          this.prod.enable_phone = false;
          return false;
        }
      },
      isEqualPartner(n){
        if(n && this.partner_id>0){
          this.equalPartner();
        }
      },
      'prod.category1_id'(n){
        this.cat2 = this.get_cat(this.catArr2, n);
      },
      'prod.category2_id'(n){
        this.cat3 = this.get_cat(this.catArr3, n)
      },
      '$store.getters.prodTab'(n) {
        document.body.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    created() {
      this.$store.commit('setProdTab', 0);
      if(this.$route.query.id)
        this.is_modify=true;

      if(this.$store.getters.mode==='partner'){
        this.partner_id = this.$store.getters.partner.space_partner;
      }
      this.getData();
      //this.getOrderSetting();
    },
    data() {
      return {
        inquiryConversionArr: [ { label:'없음',value:0 }, { label:'이메일문의',value:2 }],
        isFixed: false,
        enableButton: true,
        social_key: undefined,
        orderSetting: undefined,
        product_setting: undefined,
        percentCompleted: 0,
        custom_common_info_arr: [{label: '상품 정보 제공 고시',key:'enable_use_info', value: 'use_info'},
          {label: '환불 안내',key:'enable_refund_info', value: 'refund_info'}],
        loading: false,
        isEqualPartner: false,
        isEqualPartnerPhone: false,
        is_modify:false,
        selectedTab: 0,
        partners: [],
        // mode가 partner일 경우는 vuex에서 partner id 가져 옴
        partner_id:0,

        // 파트너 정보
        partner: {id:0},

        // 주문, 전환 정보
        performance:{
          visit: 0,
          inquiry: 0,
          like: 0,
          review: 0
        },
        conversion: {
          before: 0,
          after: 0
        },
        // 입고 수량
        addCount: 0,
        stockCount: 0,
        // 상품 기본 정보,
        prod:{
          enable_use_info: false,
          enable_delivery_info: false,
          enable_refund_info: false,
          code: '',
          video: '',
          partner_list: [],
          super_visor_id: '',
          priority: 99,
          sns_inquiry_type: 0,
          naver: '',
          instagram: '',
          kakao: '',
          homepage: '',
          enable_naver: false,
          enable_instagram: false,
          enable_kakao: false,
          enable_homepage: false,
          related_products: [],
          enable_age_verify: false,
          soldout: false,
          enable_prod: true,
          enable_option: false,
          first_img: '',
          imgs:[],
          simple_desc:'',
          info:'',
          name:"",
          category1_id:"",
          category2_id:"",
          category3_id:"",
          inquiry_conversion_type: 0,
          payment_type: 0,
          // 상품 공통 정보
          custom_common_info:false,
          common_info:{
            use_info:'',
            refund_info:'',
          },
          address:{
            sido: '',
            sigungu: '',
            dong: '',
            detail: '',
            post_code: '',
            old: '',
            new: ''
          },
          phone: '',
          enable_phone: false,
          tags:[]
        },
        // 맞춤 DB
        param_list:[],
        // 상품 가격 정보
        prod_price:{
          unit: 'kg',            // 단위
          start_date:'',
          end_date:'',
          is_discount: false,
          is_comm: false,
          is_point: false,
          price: 0,
          price_type:0,
          price_text:'',
          discount_type: 0,
          discount_rate: 0,
          discount_price: 0,
          discount_period_type: false,
          discount_start:'',
          discount_end:'',
          discount_time: [],
          comm_rate:0,
          comm_price:0,
          comm_type:0,
          point_type:0,
          point:0,
          point_rate:0,
          won_type: 0,
          comm_start: '',
          comm_end: '',
          burden_type: 0
        },
        // 상품 검색 정보
        prod_seo:{
          title:"",
          author:"",
          desc:"",
          keyword:""
        },
        prod_param: [],
        // 옵션
        selectors:[
          /*{
            minimum:1,
            maximum:100,
            required:true,
            selector_id:1
          }*/
        ],
        // 옵션 - 재고수량
        //selectorStocks: [],
        // 카테고리
        catArr1: [],
        cat2: [],         //1차 카테고리 관련된 카테고리만
        cat3: [],         //2차 카테고리 관련된 카테고리만
        catArr2: [],
        catArr3: [],
        // 판넬 구성 내용
        panel: {
          // 할인
          discount: {
            title: '할인 가격 설정',
            enable_discount_label: '할인 가격 사용여부',
            discount_type_label: '할인 방법',
            discount_label: '할인 후 가격'
          },
          // stock
          /*stock: {
            title: '상품 재고 설정',
            enable_stock_label: '재고 사용여부',
            input_number_label: '입고',
            order_number_label: '주문 수량',
            stock_number_label: '재고 수량',
            soldout_label: '품절 여부',
            option: {
              enable_stock_label: '재고 사용여부',
              option_label: '옵션명:',
              stock_number_label: '재고 수량'
            }
          }*/
        }
      }
    },
    computed: {
      prodTab() {
        return this.$store.getters.prodTab;
      },
      isMobile() {
        return this.$store.getters.device === 'mobile'
      },
      paymentTypeArr() {
        let list = [{label:'결제 없음',value:0},{label:'결제있음',value:1},{label:'현장결제',value:2}];
        return list;
      },
      isPartner () {
        return this.$store.getters.mode==='partner';
      },
      verifyTitle () {
        if(this.isInternalPlugin('age_verify')) {
          return '상품 성인인증 여부';
        }
        else if(this.isInternalPlugin('identity_verify')) {
          return '상품 본인인증 여부';
        }
        else {
          return ''
        }
      },
      /*visibleStockPanel () {
        if(!this.selectedPack) return false;
        if(this.enablePanel('panel6') && [8, 10, 11].indexOf(this.selectedPack.id) === -1) {
          return !(this.selectedPack.id === 4 && this.prod.repeat_prop === 1);
        }
        else return false
      },*/
      // 필수 옵션 재고 사용 여부
      /*requiredOptionStockUsing () {
        let opt = this.selectors.filter(i => i.option_type === 0);
        return opt.length > 0 ? opt[0].stock_using : false;
      },*/
      // 파트너 이름
      partnerName(){
        return this.partner_id > 0 && this.partners.length > 0 ? find(this.partners, 'value', this.partner_id).name : '';
      }
    },
    methods: {
      closeOption() {
        this.$modal.hide('optionModal');
      },
      /*getOrderSetting() {
        // OrderSetting 호출 (기본 결제방식, 무통장입금 은행)
        this.$axios.get(this.getUrl('v1/order/setting')).then(res => {
          this.orderSetting = res.data;
        });
        this.$axios.get('admin/service/social_key').then(res => {
          if (res.status === 200) {
            if(res.data && res.data.social_key) this.social_key = res.data.social_key
          }
        });
      },*/
      /*getProductSetting() {
        this.$axios.get('admin/product/setting').then(res=> {
          this.product_setting = res.data;
          this.prod.enable_use_info = this.product_setting.enable_use_info;
          this.prod.enable_refund_info = this.product_setting.enable_refund_info;
        })
      },*/
      selectPartnerId (res) {
        let partner_id = res.value;
        if(partner_id==='') {
          partner_id = 0;
        } else {
          this.isEqualPartnerPhone = true;
        }
        this.partner_id = partner_id;
        if(this.isEqualPartner) this.isEqualPartner = false;
      },
      getProdInfoForm() {
        this.$axios.get('public/text/form', {
          params: {
            type: 'prod_info'
          }
        }).then(res => {
          if(res.data) {
            this.prod.info = res.data.text;
          }
        })
      },
      selDateMin(date){
        this.prod_price.comm_start=date;
      },
      selDateMax(date){
        this.prod_price.comm_end=date;
      },
      // 상품 수정 페이지 일경우 호출( 할인 후 가격을 계산 )
      getCalculatePrice() {
        if(this.prod_price.comm_type===0){
          this.onEdit({text:this.prod_price.comm_rate, value:this.prod_price.comm_type}, 'comm');
        }
        else if(this.prod_price.comm_type===1){
          this.onEdit({text:this.prod_price.comm_price, value:this.prod_price.comm_type}, 'comm');
        }
        if(this.prod_price.discount_type===0){
          this.onEdit({text:this.prod_price.discount_rate, value:this.prod_price.discount_type}, 'discount');
        }
        else if(this.prod_price.discount_type===1){
          this.onEdit({text:this.prod_price.discount_price, value:this.prod_price.discount_type}, 'discount');
        }
        if(this.prod_price.point_type===0){
          this.onEdit({text:this.prod_price.point_rate, value:this.prod_price.point_type}, 'point');
        }
        else if(this.prod_price.point_type===1){
          this.onEdit({text:this.prod_price.point, value:this.prod_price.point_type}, 'point');
        }
      },
      clickCategory(value, type) {
        if (type === 'cat1') {
          this.prod.category1_id = value;
          this.prod.category2_id = '';
          this.prod.category3_id = '';
        }
        else if (type === 'cat2') {
          this.prod.category2_id = value;
          this.prod.category3_id = '';
        }
        else if (type === 'cat3') {
          this.prod.category3_id = value;
        }
      },
      selectedCategory(cat_id, type) {
        let arr = this[type === 'cat1' ? 'catArr1' : type].filter(item => { return item.value === cat_id });
        return arr.length > 0 ? arr[0].label : '';
      },
      equalPartnerPhone() {
        let partner_id = this.getPartnerId();
        this.$axios.get(this.getUrl('space/partner/' + partner_id)).then(res => {
          if (res.status === 200) {
            this.prod.phone = res.data.partner.phone;
          }
        })
      },
      equalPartner() {
        let partner_id = this.getPartnerId();
        this.$axios.get(this.getUrl('space/partner/' + partner_id)).then(res => {
          if (res.status === 200) {
            this.prod.name = res.data.partner.name;
            if(res.data.partner.address){
              if(this.prod.address) {
                let address = res.data.partner.address;
                address.id = this.prod.address.id;
                this.prod.address = address;
              } else {
                this.prod.address = res.data.partner.address;
              }
            }
            this.prod.imgs = res.data.partner.imgs;
            this.prod.first_img = res.data.partner.first_img;
            this.prod.simple_desc = res.data.partner.simple_desc;
            this.prod.info = res.data.partner.info;
          }
        })
      },
      getPartnerId() {
        let partner_id = '';
        if(this.$store.getters.mode==='admin') {
          partner_id = this.partner_id;
        }
        else if(this.$store.getters.mode==='partner'){
          partner_id = this.$store.getters.partner.space_partner;
        }
        return partner_id;
      },
      // 상품 노출 여부
      onSelectedProdState(val) {
        this.prod.enable_prod = val;
      },
      // radio edit반환값
      onEdit(res, type) {
        if(res.text==='' || res.text===0) res.text=0;
        if ( type === 'comm' ){
          if (res.value === 0) {
            this.prod_price.comm_rate = parseFloat(res.text);
          }
          else {
            this.prod_price.comm_price = parseInt(res.text);
          }
        }
        else if ( type === 'point' ){
          if (res.value === 0) {
            this.prod_price.point_rate = parseFloat(res.text);
          }
          else {
            this.prod_price.point = parseInt(res.text);
          }
        }
        this.calcPrice();
      },
      updatePrice(res) {
        ['sale_price', 'price', 'is_discount', 'discount_price', 'discount_rate', 'discount_type'].forEach(key=>{
          this.prod_price[key] = res[key];
        });
      },
      showProduct() {
        const a = document.createElement('a');
        a.href = `${this.$store.getters.brand.domain}/space_product_detail?id=${this.$route.query.id}`
        a.target = '_blank';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
      },
      saveData(){
        // 관리자 경우는 승인 요청과 상관없이 상품 승인 자동
        // 파트너 일경우만 체크함
        /*if(!this.isAdmin && this.is_modify===false) {
          // 상품 승인요청 여부 사용했을 경우
          if(this.isInternalPlugin('product_approval')) {
            // 상품 승인 타입 (미승인)
            this.prod.approval_type = 0;
          }
          // 사용 안할 경우
          else {
            // 상품 승인 타입 (승인)
            this.prod.approval_type = 1;
          }
        }*/
        this.saveProduct();
      },
      // 상품 등록 api
      async saveProduct() {
        let err = '';
        if(!this.prod.name) err = '상품이름을 입력하세요.';

        if(this.$store.getters.mode==='admin'){
          if(!this.partner_id) err = '파트너를 선택하세요.';
        }
        if(this.prod.enable_option && this.selectors.length===0) {
          err = '상품옵션을 구성해 주세요.';
        }
        if(this.$refs.productPrice && this.$refs.productPrice.errorTime) {
          err = '시작 시간/종료 시간 범위 설정이 잘못되었습니다.';
        }
        if(this.$refs.productPrice && this.$refs.productPrice.errorDiscountTime) {
          err = '시작 시간/종료 시간 범위 설정이 잘못되었습니다.';
        }
        if(!this.prod.category1_id) err = '카테고리를 선택해주세요.';

        if(err){
          this.toast(err);
          return;
        }
        // 버튼 (비)활성화 처리
        if(!this.enableButton) {
          return;
        }
        this.enableButton = false;

        let config = '';
        if(this.prod.video) {
          this.showProgressToast('상품 저장중..', 0);
          let vm = this;
          config = {
            onUploadProgress: (progressEvent)=> {
              let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
              vm.percentCompleted = percentCompleted;
              this.showProgressToast('상품 저장중..', percentCompleted);
            }
          }
        }
        else this.$store.commit('setLoading', true);
        // 수정시
        if(this.is_modify){
          let url = `space/product/${this.$route.query.id}`;
          let prod = this.cloneItem(this.prod);
          let prod_price = this.cloneItem(this.prod_price);
          if(!this.prod_price.start_date){
            prod_price.start_date = this.moment().format('YYYY-MM-DD 00:00');
          }
          if(!this.prod_price.end_date){
            prod_price.end_date = '9999-01-01 00:00';
          }
          let params = {
            product: prod,
            price: prod_price,
            seo: this.prod_seo,
            params: this.prod_param,
            selectors: this.selectors,
            //selectorStocks: this.selectorStocks,
          }
          if(this.$store.getters.mode==='admin') {
            prod.partner_id = this.partner_id;
          }
          else if(this.$store.getters.mode==='partner') {
            prod.partner_id = this.$store.getters.partner.space_partner;
          }

          this.$axios.patch(this.getUrl(url),params, config).then(res=>{
            if(res.status===200){
              this.enableButton = true;
              if(this.prod.video) this.closeProgressToast();
              else this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');

              // 상품 목록으로 이동
              this.$router.push(this.$route.path.replace('/create',''));

              // this.getData();
              // this.$refs.productTime.initRepeatPropArr();
            }
          }).catch(error=>{
            this.enableButton = true;
            if(this.prod.video) this.closeProgressToast();
            else this.$store.commit('setLoading', false);
            if (error.response) {
              if(error.response.data.message) this.toast(error.response.data.message);
              else this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
            }
          });
        }
        // 등록시
        else{
          let url='space/product';
          let prod = this.cloneItem(this.prod);
          prod.partner_id = this.$store.getters.partner.space_partner;
          let prod_price = this.cloneItem(this.prod_price);
          if(!this.prod_price.start_date){
            prod_price.start_date = this.moment().format('YYYY-MM-DD 00:00');
          }
          if(!this.prod_price.end_date){
            prod_price.end_date = '9999-01-01 00:00';
          }
          let params = {
            product: prod,
            price: prod_price,
            seo: this.prod_seo,
            params: this.prod_param,
            selectors: this.selectors,
            //selectorStocks: this.selectorStocks
          }
          if(this.$store.getters.mode==='admin') {
            prod.partner_id = this.partner_id;
          }
          this.$axios.post(this.getUrl(url), params, config).then(res=>{
            if(res.status===200){
              this.enableButton = true;
              this.prod.id = res.data;
              if(this.prod.video) this.closeProgressToast();
              else this.$store.commit('setLoading', false);
              this.$store.commit('openModal', {
                type: 'modal-product-reg',
                value: {product_id: res.data, package: 'space'},
                background: true,
                width: 360,
              })
            }
          }).catch(error=>{
            this.enableButton = true;
            if(this.prod.video) this.closeProgressToast();
            else this.$store.commit('setLoading', false);
            if (error.response) {
              if(error.response.data.message) this.toast(error.response.data.message);
              else this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
            }
          });
        }
      },
      calcPrice() {
        // 할인
        if (this.prod_price.discount_type === 0)
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - (this.prod_price.price * parseFloat(this.prod_price.discount_rate) / 100);
        else if(this.prod_price.discount_type === 1)
          this.prod_price.saleDiscount = parseInt(this.prod_price.price) - parseInt(this.prod_price.discount_price);

        // 수수료
        if (this.prod_price.comm_type === 0)
          this.prod_price.saleComm = parseInt(this.prod_price.price) * parseFloat(this.prod_price.comm_rate) / 100;
        else if(this.prod_price.comm_type === 1)
          this.prod_price.saleComm = parseInt(this.prod_price.comm_price);

        // 포인트
        if (this.prod_price.point_type === 0)
          this.prod_price.salePoint = parseInt(this.prod_price.price) * parseFloat(this.prod_price.point_rate) / 100;
        else if(this.prod_price.point_type === 1)
          this.prod_price.salePoint = parseInt(this.prod_price.point);

      },
      paramAllList(){
        // 파라미터 리스트
        this.$axios.get(this.getUrl('space/product/param')).then(res=>{
          if(res.status===200){
            this.param_list = res.data;

            let result = this.paramChecker(this.param_list, this.prod_param)
            if(result.length > 0) this.prod_param = this.prod_param.concat(result);
          }
        })
      },
      async getData(){
        // 파트너 검색 드롭다운 데이터 가져오기
        if(this.$store.getters.mode==='admin') {
          this.$axios.get('admin/space/partner/simple').then(res => {
            this.partners = res.data;
          })
        }

        if(this.$route.query.id) {
          // 상품 상세 가져오기
          this.$axios.get(this.getUrl('space/product/' + this.$route.query.id))
            .then(res => {
              if (res.status === 200) {
                this.prod = res.data.product;
                this.prod_price = res.data.price;
                if (this.prod_price.end_date.indexOf('9999-01-01') > -1) {
                  this.prod_price.end_date = '';
                }
                this.prod_seo = res.data.seo;
                this.partner_id = res.data.product.partner;
                this.prod_param = res.data.params;
                this.performance = res.data.performance;
                this.conversion = res.data.conversion;

                let selectors = this.cloneItem(res.data.selectors);
                selectors.forEach(selector=>{
                  selector.options.forEach(option=>{
                    option.add=0;
                  })
                })
                this.selectors = selectors;
                //this.closeOption();

                if(!res.data.product.address){
                  this.prod.address = {
                    sido: '',
                    sigungu: '',
                    dong: '',
                    detail: '',
                    post_code: '',
                    old: '',
                    new: ''
                  }
                }

                for(let i=0; i<res.data.params.length; i++){
                  if(res.data.params[i].param_type===5 && !res.data.params[i].value_address){
                    res.data.params[i].value_address = {
                      sido: '',
                      sigungu: '',
                      dong: '',
                      detail: '',
                      post_code: '',
                      old: '',
                      new: ''
                    }
                  }
                }

                if(!this.prod.tags){
                  this.prod.tags = [];
                }

                this.paramAllList();
                this.getCats();
                this.$refs.productPrice.getRemains();
                this.getCalculatePrice();
                /*if (res.data.product_day_price) {
                  this.product_day_price = res.data.product_day_price;
                }*/
                this.productSituation();
              }
              else {
                // console.log('res')
              }
            })
            .catch(err => {
              // console.log(err)
            })
        }
        else {
          this.paramAllList();
          this.getCats();
          //this.getProdInfoForm();
          //this.getProductSetting();
        }

      },
      getCats(){
        // 카테고리 가져오기
        this.$axios.get(this.getUrl('space/category'))
          .then(res => {
            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
            this.cat2 = this.get_cat(this.catArr2, this.prod.category1_id);
            this.cat3 = this.get_cat(this.catArr3, this.prod.category2_id);
          });
      },

      // 옵션 팝업 꺼질때
      /*closeOption() {
        //this.selectorStocks = [];

        if(this.prod.order_conversion_type === 10 || this.prod.order_conversion_type === 11) {
          // this.selectorStocks = this.selectors;
          // 속성 옵션
          let propOptions = findArray(this.selectors, 'option_type', 0);
          if(propOptions.length>0) {
            this.opt([], propOptions, 0);
          }

          // 추가 옵션
          let addOptions = findArray(this.selectors, 'option_type', 1);
          // console.log(addOptions)
          this.selectorStocks = this.selectorStocks.concat(addOptions)
          /!*for(let i=0; i<addOptions.length; i++) {
            for(let j=0; j<addOptions[i].options.length; j++) {
              let item = addOptions[i].options[j];
              this.selectorStocks.push({
                option_type: 1,
                options: [item],
                name: item.name,
                price: item.price,
                enable_stock: false,
                add: 0,
                stock: 0,
                ordered_count: 0,
                addCount: 0,
                stockCount: 0,
              });
            }
          }*!/


        }
        else {
          // 속성 옵션
          let propOptions = findArray(this.selectors, 'option_type', 0);
          if(propOptions.length>0) {
            this.opt([], propOptions, 0);
          }

          // 추가 옵션
          let addOptions = findArray(this.selectors, 'option_type', 1);
          for(let i=0; i<addOptions.length; i++) {
            for(let j=0; j<addOptions[i].options.length; j++) {
              let item = addOptions[i].options[j];
              this.selectorStocks.push({
                option_type: 1,
                options: [item],
                name: item.name,
                price: item.price,
                enable_stock: false,
                add: 0,
                stock: 0,
                ordered_count: 0,
                addCount: 0,
                stockCount: 0,
              });
            }
          }
          if(this.$route.query.id) {
            this.$axios.post(this.getUrl(`product/${this.$route.query.id}/selector_stocks`), {stocks: this.selectorStocks})
              .then( res => {
                this.selectorStocks = res.data.stocks;
              });
          }
        }
        this.$modal.hide('optionModal');
      },*/
      /*opt(str, all, cur) {
        for(let i=0; i<all[cur].options.length; i++) {
          let item = all[cur].options[i];
          let arr = this.cloneItem(str);
          arr.push(item);
          if(cur === all.length-1) {
            let name = '';
            let price = 0;
            arr.forEach(arr_item => {
              if(name !== '') name += ' x ';
              name += arr_item.name;
              price += parseInt(arr_item.price);
            });
            this.selectorStocks.push({
              option_type: 0,
              options: arr,
              name: name,
              price: price,
              enable_stock: false,
              add: 0,
              stock: 0,
              ordered_count: 0,
              addCount: 0,
              stockCount: 0,
            });
          } else {
            // 재귀호출
            this.opt(arr, all, cur+1);
          }
        }
      },*/
      productSituation() {
        // 0: 판매중, 1: 품절, 2: 마감
        // 상품 판매 사용
        if(this.prod.enable_prod) {
          // 상품 판매 날짜가 있을 경우
          if(this.prod_price.start_date && this.prod_price.end_date){
            let isBool1 = moment(this.prod_price.start_date).isBefore(moment());
            let isBool2 = moment(this.prod_price.end_date).isAfter(moment());
            if( isBool1 && isBool2 ){
              this.prod.sale_status = 0;
            }
            else this.prod.sale_status = 2;
          }
          // 날짜 선택 안했을 경우
          else if(this.prod_price.end_date === ''){
            return this.prod.sale_status = 0;
          }
          else return this.prod.sale_status = 2;
        }
        // 상품 판매 사용안함
        else {
          return '마감';
        }
      },
      modifyCategory() {
        let url = `/office/admin/space/category/create`;
        this.$router.replace(url);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .product-short-input
    width 89px

  .lp-reg-category-box
    width 100%
    display flex

  .lp-reg-category
    border-radius 3px
    border 1px solid $warmgrey
    color $font
    margin-right 20px
    width calc(33% - 12px)
    height fit-content

  .lp-reg-category:last-child
  .lp-reg-category-un:last-child
    margin-right 0

  .lp-reg-category div
  .lp-reg-category-un div
    padding 8px
    text-align center
    font-size 0.9rem
    cursor pointer

  .lp-reg-category div
    border-bottom 1px solid $warmgrey

  .lp-reg-category div:last-child
    border-bottom 0
  .lp-reg-category div:hover
    background $warmgrey

  .lp-reg-category div.select
    background $primary
    color white

  .lp-reg-category-un
    border-radius 3px
    border 1px solid $warmgrey
    color $font
    width calc(33% - 10px)
    height fit-content
    margin-right 20px

  .lp-reg-category-un div
    border-bottom 1px solid $primary

  .lp-reg-category-un div:last-child
    border-bottom 0

  .lp-reg-category div.selected
    background $primary
    color white

  .lp-tab
    display flex
    padding 10px 24px
    color #555

  .lp-tab-selected
    border: 1px solid #ccc;
    border-bottom: 1px solid #fff;
    color: #555;
    border-radius: 3px;

  .service-conversion-info
    display flex
    justify-content space-evenly
    max-width 50%
    min-width 50%
    padding 4px 8px

  .service-conversion-info-label
    display inline-block
    width 112px
    min-width 80px
    margin 0

  .prod-reg-content
    margin-top 12px

  .lp-txt-period
    font-size 12px
    text-align center
    width 90px
    color #989898

  .box-disabled
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-color rgba(255,255,255,0.4)
    z-index 100

  :target
    top -130px
    display block
    position relative
    visibility hidden

  .level-title
    font-size 1.4rem

  .fixed
    background-color white
    position fixed
    border 1px solid #dddddd
    width calc(100% - 400px)
    left 400px
    top 49px
    z-index: 999
    padding 12px 20px

  .modify-btn
    width 76px
    gap 0 4px
    background-color rgba(255, 206, 166, 0.3)
    border none !important
    border-radius 50px

  .common-info
    margin-bottom 20px
</style>
